export enum Routes {
  LOGIN = 'login',
  LOGIN_MFA = 'login_mfa',
  HOME = 'home',
  CONTRACT_VIEW = 'contract_view',
  WALLET_CONTRACT_VIEW = 'wallet_contract_view',
  ENTITY_VIEW = 'entity_view',
  ENTITY_VIEW_INFORMATION = 'entity_view_information',
  ENTITY_VIEW_FINANCIAL_STATEMENTS = 'entity_view_financial_statements',
  ENTITY_VIEW_DOCUMENTS = 'entity_view_documents',
  ENTITY_VIEW_PROPOSALS = 'entity_view_proposals',
  ENTITY_VIEW_DEMANDS = 'entity_view_demands',
  ENTITY_VIEW_CONTRACTS = 'entity_view_contracts',
  ENTITY_VIEW_CLIENT_INVOICES = 'entity_view_client_invoices',
  ENTITY_VIEW_SUPPLIER_INVOICES = 'entity_view_supplier_invoices',
  RESTRUCTURING_LIST = 'restructuring_list',
  RESTRUCTURING_CREATE = 'restructuring_create',
  RESTRUCTURING_VIEW = 'restructuring_view',
  RESTRUCTURING_VIEW_INFORMATION = 'restructuring_view_information',
  RESTRUCTURING_VIEW_DOCUMENTS = 'restructuring_view_documents',
  RESTRUCTURING_EDIT = 'restructuring_edit',
  SIMULATION_VIEW = 'simulation_view',
  USER_TOTP_SETUP = 'user_totp_setup',
  NOTIFICATIONS_VIEW = 'notifications-view',
}
